import _ from 'lodash'
import moment from 'moment'
import { PricingSystemTypes } from '@/store/types'

export default {
  namespaced: true,
  state: {
    countryCode: '',
    stateCode: '',
    currencyCode: '',
    salesTaxRate: {},
    accountSettings: [],
    pricingSystemType: PricingSystemTypes.simple,
    isAccountInitialBillingSetup: true,  // Important to default to true initially
    isAccountActivated: true,       // Important to default to true initially
    isAccountLoaded: false,
    hasActiveSubscription: true,    // Set to true initially to avoid flickering warnings
    isSubscriptionExpired: false,
    isSubscriptionExpiringSoon: false,
    subscriptionExpiryDate: null,
    prodAvailableUserCount: 0,
    prodAvailableStorageGigabytes: 0,
    prodFeatureList: [],
    accountLocations: []
  },
  getters: {
    getAccLocationById: (state) => (accountLocationId) => {
      return state.accountLocations.find(accLocation => accLocation.id == accountLocationId)
    }
  },
  mutations: {
    setAccountData (state, accountData) {
      state.countryCode = accountData.countryCode
      state.stateCode = accountData.stateCode
      state.currencyCode = accountData.currencyCode
      state.salesTaxRate = accountData.salesTaxRate ? _.clone(accountData.salesTaxRate) : {}
      state.pricingSystemType = accountData.pricingSystemType
      state.accountSettings = _.cloneDeep(accountData.accountSettings)
      state.isAccountLoaded = true
      state.isAccountInitialBillingSetup = accountData.isAccountInitialBillingSetup
      state.isAccountActivated = accountData.isAccountActivated
      state.accountLocations = accountData.accountLocations

      state.isSubscriptionExpired = false
      state.isSubscriptionExpiringSoon = false
      state.hasActiveSubscription = false

      if(accountData.subscription) {
        state.isSubscriptionExpired = !accountData.subscription.isActive
        state.subscriptionExpiryDate = accountData.subscription.expiryDate

        // If auto-renew is off & the expiry is within 14 days, flag a warning for subscription expiring soon
        if(accountData.subscription.isActive && !accountData.subscription.isAutoRenewEnabled) {
          let warningDayCount = 14
          if(moment().add(warningDayCount, 'days').isAfter(moment(accountData.subscription.expiryDate)))
            state.isSubscriptionExpiringSoon = true
        }
      }
      if(accountData.accountProductAccess) {
        state.hasActiveSubscription = !!accountData.accountProductAccess.hasActiveSubscription
        state.prodAvailableUserCount = parseInt(accountData.accountProductAccess.availableUserCount || 0)
        state.prodAvailableStorageGigabytes = parseInt(accountData.accountProductAccess.availableStorageGigabytes || 0)
        state.prodFeatureList = (accountData.accountProductAccess.featureList || [])
      }
    },
    setAccountInitialBillingSetup(state) {
      state.isAccountInitialBillingSetup = true
    },
    setAccountActivated(state) {
      state.isAccountActivated = true
    },
    clearAccountData (state) {
      state.countryCode = ''
      state.stateCode = ''
      state.currencyCode = ''
      state.salesTaxRate = {}
      state.accountSettings = []
      state.pricingSystemType = PricingSystemTypes.simple
      state.isAccountLoaded = false
      state.isAccountInitialBillingSetup = true  // Important to default to true initially
      state.isAccountActivated = true       // Important to default to true initially
      state.hasActiveSubscription = false
      state.isSubscriptionExpired = false
      state.displaySubscriptionExpireWarning = false
      state.prodAvailableUserCount = 0
      state.prodAvailableStorageGigabytes = 0
      state.prodFeatureList = []
      state.accountLocations = []
    }
  }
}
